import CustomToast from "../components/UI/customToast";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../constants/PublicVariables";
import Localize from "../locale/Localize";
import { updateRecordingStatus } from "../reducers/recording-reducer";
import { LogFirebase } from "../services/firestore";
import recordingService from "../services/recordingService";

export const handleStartRecording = () => async (dispatch) => {
    dispatch(updateRecordingStatus({ recordingType: "stopRecording" })); // reset stop recording state when start recording
    dispatch(updateRecordingStatus({ recordingType: "startRecording", loading: true }));
    try {
        const response = await recordingService.startRecordingService();
        dispatch(updateRecordingStatus({ recordingType: "startRecording", data: response }));
    } catch (error) {
        dispatch(updateRecordingStatus({ recordingType: "startRecording", error: error }));
    }
};

export const resetStartRecordingData = () => (dispatch) => {
    dispatch(updateRecordingStatus({ recordingType: "startRecording", reset: true }));
};

export const resetStopRecordingData = () => (dispatch) => {
    dispatch(updateRecordingStatus({ recordingType: "stopRecording", reset: true }));
};

export const handleStopRecording = () => async (dispatch) => {
    dispatch(updateRecordingStatus({ recordingType: "startRecording" })); // reset start recording state when stop recording
    dispatch(updateRecordingStatus({ recordingType: "stopRecording", loading: true }));
    try {
        const response = await recordingService.stopRecordingService();
        dispatch(updateRecordingStatus({ recordingType: "stopRecording", data: response }));
        CustomToast.success(Localize[PublicVariables.currentLanguageObj.languageCode]["recording_stopped"]);
    } catch (error) {
        dispatch(updateRecordingStatus({ recordingType: "stopRecording", error: error }));
    }
};

export const handleRoomAlertAPI = async (roomType) => {
    const sessionID = GLOBAL_MEETING_DATA.sessionId;
    /*  this msg used for the show alert msg in slack alert
         this line will not locklized 
    */
    const requestMessage = {
        message: roomType + " room participant limit reached for the meeting ID: " + sessionID + " and domain URL: " + window.location.origin,
    };

    try {
        const response = await recordingService.handleRoomAlertAPI(requestMessage);
        LogFirebase("GO_ROOM", "Alert", response);
    } catch (error) {
        console.error(error);
        LogFirebase("GO_ROOM", "Alert", error);
    }
};
